(() => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const el = entry.target;
        const rect = el.getBoundingClientRect();
        const isHiddenVertically = rect.top < 0 || rect.bottom > window.innerHeight;

        if (isHiddenVertically) {
          const delay = el.dataset.delay;
          if (delay) el.style.transitionDelay = `${delay}ms`;
        }

        el.dataset.fadeInUp = "visible";
        observer.unobserve(el);
      });
    },
    { threshold: 0.1 },
  );

  document.querySelectorAll("[data-fade-in-up]").forEach((el) => observer.observe(el));
})();
